<template>
	<router-view></router-view>
</template>

<script>
    export default {
        name: "customer-order-index"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/layouts/customerorder/CustomerOrderIndex.vue